import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { asyncReceiveLeaderboards } from '../states/leaderboard/action';

export default function LeaderboardPage() {
  const { leaderboards } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(asyncReceiveLeaderboards());
  }, [dispatch]);

  return (
    <section>
      <h1 className="text-2xl font-bold mb-8">Leaderboards</h1>
      <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left">
          <thead className="text-xs font-semibold text-zinc-600 uppercase bg-zinc-200 dark:bg-zinc-900/70 dark:text-zinc-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <th scope="col" className="py-3 px-6">
                Name
              </th>
              <th scope="col" className="py-3 px-6">
                score
              </th>
            </tr>
          </thead>
          <tbody>
            {leaderboards?.length ? (
              leaderboards.map((leaderboard, index) => (
                <tr
                  key={leaderboard?.user?.id}
                  className="bg-white border-b dark:bg-zinc-900/30 dark:border-zinc-700 hover:bg-zinc-200/50 dark:hover:bg-zinc-900">
                  <td className="py-4 px-6">{index + 1}</td>
                  <td className="flex items-center py-4 px-6 text-zinc-900 whitespace-nowrap dark:text-white">
                    <img
                      className="w-10 h-10 rounded-full"
                      src={leaderboard?.user?.avatar}
                      alt={leaderboard?.user?.name}
                    />
                    <div className="pl-3">
                      <div className="text-base font-semibold">
                        {leaderboard?.user?.name}
                      </div>
                      <div className="font-normal text-zinc-500">
                        {leaderboard?.user?.email}
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6">{leaderboard?.score}</td>
                </tr>
              ))
            ) : (
              <tr className="bg-white border-b dark:bg-zinc-900/30 dark:border-zinc-700 hover:bg-zinc-200/50 dark:hover:bg-zinc-900">
                <td className="py-4 px-6 text-center" colSpan={3}>
                  No data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
